/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import BaseService from '../../../services/BaseService';
import { ChartCard } from '../RelatorioDigitacao/chartShared';
import ChartFocusDialog from '../RelatorioDigitacao/ChartFocusDialog';
import PeriodoHistoricoChart from './PeriodoHistoricoChart';
import {
  EMPTY_PERIODO_HISTORICO,
  buildHistoricoFilterForApi,
  normalizePeriodoHistorico,
} from './constants';

const FOCUS_HEIGHT = 520;
const TITLE = 'Evolução por período';

const PeriodoHistoricoSection = ({ localFilter, refreshKey }) => {
  const [data, setData] = useState(EMPTY_PERIODO_HISTORICO);
  const [loading, setLoading] = useState(false);
  const [focusOpen, setFocusOpen] = useState(false);

  const apiFilter = useMemo(
    () => buildHistoricoFilterForApi(localFilter),
    [localFilter],
  );

  const fetchHistorico = useCallback(async () => {
    setLoading(true);
    try {
      const response = await BaseService.post({
        url: 'reports/uso-mutuo/charts/by-period',
        data: apiFilter,
      });
      setData(normalizePeriodoHistorico(response?.data));
    } catch {
      setData(EMPTY_PERIODO_HISTORICO);
    } finally {
      setLoading(false);
    }
  }, [apiFilter, refreshKey]);

  useEffect(() => {
    fetchHistorico();
  }, [fetchHistorico]);

  return (
    <>
      <ChartCard title={TITLE} onExpand={() => setFocusOpen(true)} contentSx={{ pl: 1, pr: 2 }}>
        <PeriodoHistoricoChart
          items={data.items}
          materialColumns={data.materialColumns}
          loading={loading}
        />
      </ChartCard>

      <ChartFocusDialog open={focusOpen} title={TITLE} onClose={() => setFocusOpen(false)}>
        <PeriodoHistoricoChart
          items={data.items}
          materialColumns={data.materialColumns}
          loading={loading}
          height={FOCUS_HEIGHT}
        />
      </ChartFocusDialog>
    </>
  );
};

PeriodoHistoricoSection.propTypes = {
  localFilter: PropTypes.object.isRequired,
  refreshKey: PropTypes.bool,
};

PeriodoHistoricoSection.defaultProps = {
  refreshKey: false,
};

export default PeriodoHistoricoSection;
